import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { ThemeProp } from "../../../styles/theme";
import styled from "@emotion/styled";

interface MakerSectionHeaderProps {
  isSending: boolean;
}

export const MakerSectionHeader: React.FC<MakerSectionHeaderProps> = ({ isSending }) => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <MakerSectionText theme={theme}>
      You {isSending ? "Send Exactly" : "Receive Exactly"}
    </MakerSectionText>
  );
};

export const MakerSectionText = styled.span<ThemeProp>(({ theme }) => ({
  color: theme.font.primary.default,
}));
